export default "__VITE_ASSET__f060173d__"